// ─────────────────────────────────────────────
//  Pure helpers for the user avatar circle.
//  Doctors show their short code; everyone else shows first+last initials.
// ─────────────────────────────────────────────

const clean = (str) => (str || "").trim();

// First letter of each of the first two words, uppercased. A single word
// degrades to its first two letters so the circle is never blank.
function initialsFromName(name) {
  const parts = clean(name).split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

// First+last initials, preferring the explicit name fields and falling back to
// the legacy single `name` field for users created before the profile split.
export function userInitials(user) {
  const first = clean(user?.firstName);
  const last = clean(user?.lastName);
  if (first || last) {
    return ((first[0] || "") + (last[0] || "")).toUpperCase();
  }
  return initialsFromName(user?.name);
}

// What the avatar circle displays. Doctors → short code (fallback to initials
// until a code is assigned); everyone else → first+last initials.
export function avatarText(user, isDoctor) {
  if (isDoctor) {
    const code = clean(user?.shortCode).toUpperCase();
    if (code) return code;
  }
  return userInitials(user) || "?";
}
